<!--
  @author:chen.hao
  @time:2018/11/7
  @disc:报价管理弹出层信息展示
 -->

<template>
  <el-form label-width="100px">
    <div class="info-block">
      <el-form-item label="供应商信息" class="title-info"></el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户名">{{infoData.username}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册时间">{{infoData.registrationTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称">{{infoData.companyName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册手机号">{{infoData.registrationPhone}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="营业执照">{{infoData.licence}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人代表">{{infoData.repLglPerson}}</el-form-item>
        </el-col>
      </el-row>
    </div>
    <div class="info-block">
      <el-form-item label="商品信息" class="title-info"></el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品名称">{{infoData.itemName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品编码">{{infoData.itemCode}}</el-form-item>
        </el-col>
      </el-row>
    </div>
    <div class="info-block">
      <el-form-item label="报价信息" class="title-info"></el-form-item>
      <el-form-item label="商品报价">
        <template v-if="infoData.quotedPriceType===1">
          一口价:{{infoData.fixedPrice}}元/吨
        </template>
        <template v-if="infoData.quotedPriceType===2">
          阶梯价:<span v-for="(item,index) in infoData.diffPricings" :key="'price'+index">
            {{item.start}}-{{item.end}}吨，{{item.price}}元/吨;
          </span>
        </template>
      </el-form-item>
      <el-form-item label="物流报价">
        首重{{infoData.initialWeight}}吨，{{infoData.initialCharge}}元/KM;
        每增加{{infoData.stepWeight}}吨，增加运费{{infoData.stepCharge}}元/KM
      </el-form-item>
      <el-form-item label="商品描述">{{infoData.itemDesc}}</el-form-item>
      <el-form-item label="商品展示图">
        <img-view :src="item" alt="" v-for="(item,index) in infoData.itemPics" :key="'img'+index" class="img-view"/>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import ImgView from '../../../components/imgView/index'
export default {
  name: 'info',
  components: { ImgView },
  props: ['infoData']
}
</script>

<style scoped>
.img-view {
  width: 150px;
  height: 150px;
  float: left;
  margin-right: 10px;
}

/deep/ .title-info .el-form-item__label {
  font-weight: bold;
  font-size: 16px;
  width: auto !important;
}
</style>
